// @flow

import {combineReducers} from 'redux';
import {authReducer} from 'modules/auth/reducers/auth';

const reducers = {
    auth: authReducer,
};

type TAuthModuleState = {};

const authModuleReducer = combineReducers(reducers);
export {authModuleReducer};
export type {TAuthModuleState};
